import { baseApi } from "../baseApi";

/**
 * Admin API endpoints for registration code management
 */
const registrationCodesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all registration codes
    getRegistrationCodes: builder.query({
      query: () => ({
        url: "/api/registration-codes",
        method: "GET",
      }),
      providesTags: ["RegistrationCode"],
    }),

    // Create a new registration code
    createRegistrationCode: builder.mutation({
      query: (codeData) => ({
        url: "/api/registration-codes",
        method: "POST",
        body: codeData,
      }),
      invalidatesTags: ["RegistrationCode"],
    }),

    // Validate registration code (public endpoint)
    validateRegistrationCode: builder.query({
      query: (code) => ({
        url: `/api/registration-codes/validate/${code}`,
        method: "GET",
      }),
    }),

    // Update a registration code
    updateRegistrationCode: builder.mutation({
      query: ({ id, ...updates }) => ({
        url: `/api/registration-codes/${id}`,
        method: "PUT",
        body: updates,
      }),
      invalidatesTags: (result, error, { id }) => [
        "RegistrationCode",
        { type: "RegistrationCode", id },
      ],
    }),

    // Deactivate a registration code
    deactivateRegistrationCode: builder.mutation({
      query: (id) => ({
        url: `/api/registration-codes/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RegistrationCode"],
    }),

    // Reactivate a registration code
    reactivateRegistrationCode: builder.mutation({
      query: (id) => ({
        url: `/api/registration-codes/${id}/reactivate`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [
        "RegistrationCode",
        { type: "RegistrationCode", id },
      ],
    }),

    // Get registration code statistics
    getRegistrationCodeStats: builder.query({
      query: (id) => ({
        url: `/api/registration-codes/${id}/stats`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [
        { type: "RegistrationCode", id },
        "User",
      ],
    }),
  }),
});

export const useGetRegistrationCodesQuery =
  registrationCodesApi.useGetRegistrationCodesQuery;
export const useCreateRegistrationCodeMutation =
  registrationCodesApi.useCreateRegistrationCodeMutation;
export const useValidateRegistrationCodeQuery =
  registrationCodesApi.useValidateRegistrationCodeQuery;
export const useUpdateRegistrationCodeMutation =
  registrationCodesApi.useUpdateRegistrationCodeMutation;
export const useDeactivateRegistrationCodeMutation =
  registrationCodesApi.useDeactivateRegistrationCodeMutation;
export const useReactivateRegistrationCodeMutation =
  registrationCodesApi.useReactivateRegistrationCodeMutation;
export const useGetRegistrationCodeStatsQuery =
  registrationCodesApi.useGetRegistrationCodeStatsQuery;
